module.exports = __webpack_public_path__ + "media/images/icons/arrow-left-blue-9e2230221db21027989d133661ae3bb8.svg";